import { render } from "./EquipmentView.vue?vue&type=template&id=08036776&scoped=true"
import script from "./EquipmentView.vue?vue&type=script&lang=js"
export * from "./EquipmentView.vue?vue&type=script&lang=js"

import "./EquipmentView.vue?vue&type=style&index=0&id=08036776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08036776"]])

export default __exports__